import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import TablePagination from "@mui/material/TablePagination";
import Typography from "@mui/material/Typography";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import TablePaginationActions from "../../../shared/components/Table/Actions";
import { dateTimeFormat } from "../../../util/DateUtil";
import Loading from "../../UI/Loading";

const getLeituraStatus = (comunicadoUsuario) => {
  if (comunicadoUsuario.leituraConfirmada) {
    return { label: "Leitura confirmada", color: "success" };
  }
  if (comunicadoUsuario.visualizado) {
    return { label: "Leitura não confirmada", color: "warning" };
  }
  return { label: "Novo", color: "primary" };
};

const Thumbnail = ({ comunicado }) => (
  <Box
    sx={{
      width: { xs: "100%", sm: 160 },
      aspectRatio: "16 / 9",
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: 1.5,
      overflow: "hidden",
      bgcolor: "action.hover",
      color: "text.disabled",
    }}
  >
    {comunicado.comunicadoBanner ? (
      <Box
        component="img"
        src={comunicado.comunicadoBanner.urlBanner}
        alt=""
        loading="lazy"
        sx={{ width: "100%", height: "100%", objectFit: "contain" }}
      />
    ) : (
      <CampaignOutlinedIcon fontSize="large" />
    )}
  </Box>
);

const ComunicadoUsuarioList = ({ listCU, isLoading, handleChangePage, handleRowClick }) => {
  if (isLoading) {
    return (
      <Box py={6}>
        <Loading description="Carregando Comunicados..." />
      </Box>
    );
  }

  if (listCU.content.length === 0) {
    return (
      <Box
        sx={{
          py: 6,
          textAlign: "center",
          color: "text.secondary",
          border: 1,
          borderStyle: "dashed",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <CampaignOutlinedIcon fontSize="large" />
        <Typography variant="body2" mt={1}>
          Nenhum comunicado encontrado.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Stack spacing={1.5}>
        {listCU.content.map((cu) => {
          const status = getLeituraStatus(cu);
          const novo = !cu.visualizado;
          return (
            <Card
              key={cu.codigo}
              variant="outlined"
              sx={{
                borderLeft: 4,
                borderLeftColor: novo ? "primary.main" : "divider",
                transition: "box-shadow .2s",
                "&:hover": { boxShadow: 3 },
              }}
            >
              <CardActionArea onClick={() => handleRowClick(cu)} sx={{ p: 2 }}>
                <Stack direction={{ xs: "column", sm: "row" }} spacing={2} alignItems={{ sm: "center" }}>
                  <Thumbnail comunicado={cu.comunicado} />
                  <Box flexGrow={1} minWidth={0}>
                    <Typography variant="subtitle1" fontWeight={novo ? 700 : 500}>
                      {cu.comunicado.titulo}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Enviado em {dateTimeFormat(cu.createdAt)}
                      {cu.aluno && ` · Aluno: ${cu.aluno.nome}`}
                    </Typography>
                    {cu.comunicado.dataHoraPara && (
                      <Chip
                        size="small"
                        color="warning"
                        variant="outlined"
                        icon={<EventOutlinedIcon />}
                        label={`Para: ${dateTimeFormat(cu.comunicado.dataHoraPara)}`}
                        sx={{ mt: 1 }}
                      />
                    )}
                  </Box>
                  <Chip
                    size="small"
                    label={status.label}
                    color={status.color}
                    variant={novo ? "filled" : "outlined"}
                    sx={{ alignSelf: { xs: "flex-start", sm: "center" } }}
                  />
                </Stack>
              </CardActionArea>
            </Card>
          );
        })}
      </Stack>

      <TablePagination
        rowsPerPageOptions={[]}
        rowsPerPage={listCU.size || 0}
        component="div"
        count={listCU.totalElements}
        page={listCU.number}
        onPageChange={handleChangePage}
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? `${count} registros` : `mais de ${to}`}`
        }
        ActionsComponent={TablePaginationActions}
        sx={{ mt: 1 }}
      />
    </Box>
  );
};

export default ComunicadoUsuarioList;
